import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubsemnatComponent } from './subsemnat.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { InformatiiAditionaleComponent } from 'src/app/components/cereri/cereri-detalii/informatii-aditionale/informatii-aditionale.component';

@NgModule({
    declarations: [SubsemnatComponent, InformatiiAditionaleComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
    exports: [SubsemnatComponent],
})
export class SubsemnatModule { }
